import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
  
    Row,
    Col,
    Button,
    Space,
    Card,
    Avatar,
    Typography
   
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
const { Text, Link } = Typography;

let styles = {
    studentInfoCard: {
        border:'0px'
    },
    studentPersonalInfo : {
        textAlign:'left',
        backgroundColor:'rgb(204, 247, 138)',
        padding:'10px 20px',
        borderTopLeftRadius:'10px',
        borderBottomLeftRadius:'10px',
        borderRight:'3px solid #fff'
    },
    studentOtherinfo :  {
        textAlign:'left',
        backgroundColor:'rgb(16, 94, 10)',
        padding:'10px',
        borderTopRightRadius:'10px',
        borderBottomRightRadius:'10px',

        h4_design : {
            color:'#fff'
        },
        h1_design : {
            fontSize:'1.5rem',
            color:'#fff'
        }
    }
  }

const StudentCardInfo = ({memberDisplayInfo,memberDisplayOtherInfo}) => {
    const PROFILE_URL = `http://btaportal.in/backend/app/uploads/profile/${memberDisplayInfo.profilePic}`
    const [profileUrl,setProfileUrl] = useState(PROFILE_URL)
    // console.log("memberDisplayInfo", memberDisplayInfo);
    // console.log("memberDisplayOtherInfo", memberDisplayOtherInfo);

    return (
        <div>
            {
                memberDisplayInfo.memberName.length > 0 ? <>
                
                <Card
                title=""

                style={{
                    width: 'auto',
                }}
                className="studentInfoCard"
                style={styles.studentInfoCard}
            >


                <Row gutter={10}>
                    <Col xs={24} xl={12} className="student-personal-info"  style={styles.studentPersonalInfo}>
                        <Avatar
                            size={{
                                xs: 24,
                                sm: 32,
                                md: 40,
                                lg: 64,
                                xl: 80,
                                xxl: 100,
                            }}
                            // src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/800px-Image_created_with_a_mobile_phone.png"

                            src={profileUrl}
                            hidden={true}
                        />

                        <h2>{memberDisplayInfo.memberName}</h2>
                        {/* <h4>DOB : {memberDisplayInfo.memberDOB}</h4>
                        <h4>{memberDisplayInfo.memberPrimaryMobile}</h4> */}
                        

                        <Space direction="vertical">
                            <Text>Date of Birth : {memberDisplayInfo.memberDOB}</Text>
                            <Text>Mobile No : {memberDisplayInfo.memberPrimaryMobile}</Text>
                        </Space>
                    </Col>
                    <Col xs={24} xl={12} className="student-other-info"  style={styles.studentOtherinfo}>
                        {memberDisplayOtherInfo.group && (
                            <Text style={styles.studentOtherinfo.h4_design}>Group : {memberDisplayOtherInfo.group}</Text>
                        )}
                        <h4 style={styles.studentOtherinfo.h4_design}>DOJ : {memberDisplayOtherInfo.joinDate}</h4>
                        <Text italic style={{borderBottom:"0px dashed #fff",color:'#fff'}}>Validity </Text>
                        {/* <h1 style={styles.studentOtherinfo.h1_design}> {memberDisplayOtherInfo.validity}</h1> */}
                        <Typography.Title
                            level={5}
                            style={{
                            margin: 0,
                            color:'#FFF',
                            }}
                        >
                            {memberDisplayOtherInfo.validity}
                        </Typography.Title>
                    </Col>
                </Row>


            </Card>
                
                </> :''
            }

            
        </div>
    )
}

export default StudentCardInfo

